export default [
  {
    path: "/report-company-profit",
    name: "report-company-profit",
    meta: {
      title: "Отчёт о компании",
      authRequired: true,
    },
    component: () => import("@/modules/reports/report-company-profit/views/index.vue"),
  },
  {
    path: "/report-company-profit/expenses/:year/:month",
    name: "report-company-profit-expenses",
    meta: {
      title: "Отчёт о компании расходы за месяц",
      authRequired: true,
    },
    component: () => import("@/modules/reports/report-company-profit/views/expenses.vue"),
  },
  {
    path: "/report-company-profit/margin/:year/:month",
    name: "report-company-profit-margin",
    meta: {
      title: "Отчёт о компании маржинальность за месяц",
      authRequired: true,
    },
    component: () => import("@/modules/reports/report-company-profit/views/margin.vue"),
  },
];
